export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS';
export const GET_UNREAD_COUNT = 'GET_UNREAD_COUNT';
export const IS_LOADING = ' IS_LOADING';
